const {h, render, Component} = require('preact');
const Web2018Helper = require('../../../../helper')

class PurchaseDate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let details = this.props.claimDetails
    if (details && details.claimedAt) {
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.purchase_date")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(details.claimedAt)}</td>
        </tr>
      );
    }
    return null;
  }
}

module.exports = PurchaseDate
